import React from "react";

import { Container, Row, Col } from "reactstrap";

function AwardsPage() {
  // const size = document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024 ? true : false;
  return (
    <>
      <div
        style={{
          overflow: "hidden",
          background: "transparent",
        }}
        className="section pb-2"
      >
        <Container fluid>
          <Container>
            <Row>
              <Col lg={6} className={``}>
                <h4 className=" text-700 text-white">
                  At <b>Exibex</b>, we’re deeply committed to celebrating the visionaries,
                  innovators, and changemakers who are truly shaping the future of finance. The
                  Finnovex Saudi Arabia Awards 2025 will shine a spotlight on those who are not only
                  pushing boundaries but also leading real, transformative change in the financial
                  sector.
                  <br />
                  <br />
                  These awards are more than just titles—they are a symbol of excellence,
                  resilience, and a relentless drive for innovation. They honor the incredible
                  contributions that elevate the industry and inspire others to strive for
                  greatness.
                  <br />
                  <br />
                  By recognizing the trailblazers who are leading the way, the Finnovex Saudi Arabia
                  Awards help set the stage for a brighter future, pushing organizations to aim
                  higher and creating a culture of excellence that drives sustainable growth.
                  <br />
                  <br />
                  With great pride, we celebrate the individuals and teams who are breaking
                  barriers, defining new trends, and shaping the future of banking and financial
                  services. The Finnovex Saudi Arabia Awards 2025 aren’t just about recognition—they
                  are a testament to the power of collaboration, innovation, and the enduring
                  pursuit of excellence.
                </h4>
                <br />
              </Col>
              <Col lg={6} className={`mb-3 `}>
                <img
                  src={require("assets/images/awards/DSC_0435.JPG")}
                  width="100%"
                  alt="awards"
                  style={{
                    borderRight: "10px solid #c0dea7",
                    borderTop: "10px solid #c0dea7",
                  }}
                />
              </Col>

              {content.map((data, index) => (
                <Col lg={3} key={index} className="stat-div border">
                  <div className="d-flex align-items-center" style={{ minHeight: "125px" }}>
                    <h5 className="text-700 mt-0 text-white">{data}</h5>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </Container>
      </div>
    </>
  );
}

export default AwardsPage;

const content = [
  "Excellence in Mobile Banking",
  "Excellence in Digital Banking",
  "Excellence in Fintech",
  "Excellence in Payments",
  "Excellence in Cybersecurity",
  "Excellence in Customer Experience Enhancement",
  "Excellence in InsurTech",
  "Excellence in Open Banking",
  "Excellence in Cloud Banking",
  "Outstanding Contribution to Financial Inclusion Initiative",
  "Outstanding Contribution to Strategic National Development Initiatives",
  "Outstanding Contribution to Fintech Initiatives",
  "Finnovator of the Year, Saudi Arabia",
  "Influencer of the Year, Saudi Arabia",
  "Financial Women Trailblazer of the Year",
  "CEO of the Year",
  "COO of the Year",
  "CDO of the Year",
  "CIO of the Year",
  "CTO of the Year",
  "CFO of the Year",
  "CISO of the Year",
];

const content2 = [];
